import React from 'react';
import './styles.css';
import FormattedMessage from 'components/FormattedMessage/index';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect'; // Fixed import
import { setData } from 'ducks/actions/index';
import { makeSelectIsTermsAndConditionAccept } from 'ducks/selectors/planService';

const PaymentDetails = ({
  onAgreeChange,
  isTermsAndConditionAccept,
  setTermsAndConditionAccept
}) => {
  // Safely extract boolean value whether Redux holds a boolean or an object { isTermsAndConditionAccept: boolean }
  const isAccepted = typeof isTermsAndConditionAccept === 'object'
    ? Boolean(isTermsAndConditionAccept?.isTermsAndConditionAccept)
    : Boolean(isTermsAndConditionAccept);

  const handleTermsAndConditionChange = (e) => {
    const isChecked = e.target.checked;
    setTermsAndConditionAccept(isChecked);
    if (onAgreeChange) {
      onAgreeChange(isChecked);
    }
  };

  return (
    <div className="payment-details-container">
      <h2 className="payment-details-title">Payment details</h2>
      
      {/* Ensure FormattedMessage has fallback safety */}
      <FormattedMessage html id="ent_payment_details" defaultMessage="" />

      <div className="agree-all-container">
        <label className="agree-all-label">
          <input
            type="checkbox"
            className="agree-all-checkbox"
            checked={isAccepted}
            onChange={handleTermsAndConditionChange}
          />
          <span className="checkbox-custom" />
          <span className="agree-all-text">Agree to all</span>
        </label>
      </div>
    </div>
  );
};

export function mapDispatchToProps(dispatch) {
  return {
    setTermsAndConditionAccept: (isTermsAndConditionAccept) => {
      dispatch(
        setData({
          key: "isTermsAndConditionAccept",
          data: { isTermsAndConditionAccept }
        })
      );
    },
  };
}

const mapStateToProps = createStructuredSelector({
  isTermsAndConditionAccept: makeSelectIsTermsAndConditionAccept()
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentDetails);